(function($, window, document, s, undefined) {



/**
* Shows the tab whose tab link is the one selected by the selector.s
*/
var showTab = function showTab(selector) {
    $(selector)
        .tab('show')
        .addClass('active')
        .siblings('.active').removeClass('active');
};


/**
* Gets the GET parameter from the URL. It assumes that only a single parameter
* exists
*/
var showTabBasedOnHash = function showTabBasedOnHash() {
    var path = window.location.hash;

    if (path) {
        $('.tab-link.active').removeClass('active');
        $('.tab-pane.active').removeClass('active');
        showTab('.tab-link[href="' + path + '"]');
    }
};



var initTabs = function initTabs() {
    showTabBasedOnHash();

    $('.tab-link')
        .tab()
        .on('click', function(e){
            e.preventDefault();
            showTab(this);
            window.history.pushState('', $(this).html(), $(this).attr('href'));
        });
};


var checkForTabs = function checkForTabs() {
    if (['body-help', 'body-customer-dashboard'].indexOf(s.bodyId) > -1) {
        initTabs();
    }
};


s.callOnReady(checkForTabs);


})(jQuery, this, this.document, window.s);
